import { createSelector } from 'reselect'

export const getVenueName = state => state.venue?.currentVenue?.displayName
